import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, ArrowLeft, Check } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(`${API}/player/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error sending reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <section className="page-hero" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
        <div className="container" style={{ maxWidth: '480px' }}>
          <div className="network-card" style={{ padding: '48px 32px' }}>
            {sent ? (
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  background: 'rgba(34, 197, 94, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 24px'
                }}>
                  <Check size={40} style={{ color: '#22c55e' }} />
                </div>
                <h1 className="heading-1" style={{ marginBottom: '16px' }}>Check Your Email</h1>
                <p style={{ color: 'var(--text-light)', marginBottom: '24px' }}>
                  If an account exists with <strong>{email}</strong>, we've sent password reset instructions.
                </p>
                <Link to="/player/login" className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                  <ArrowLeft size={18} /> Back to Login
                </Link>
              </div>
            ) : (
              <>
                <Link to="/player/login" style={{ color: 'var(--text-light)', display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '24px', textDecoration: 'none' }}>
                  <ArrowLeft size={18} /> Back to Login
                </Link>
                
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                  <h1 className="heading-1" style={{ marginBottom: '8px' }}>Forgot Password?</h1>
                  <p className="body-medium" style={{ color: 'var(--text-light)' }}>
                    Enter your email and we'll send you a link to reset your password
                  </p>
                </div>

                {error && (
                  <div style={{
                    padding: '12px 16px',
                    background: 'rgba(220, 38, 38, 0.2)',
                    border: '1px solid #dc2626',
                    borderRadius: '8px',
                    color: '#ef4444',
                    marginBottom: '24px',
                    fontSize: '0.875rem'
                  }}>
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="form-group" style={{ marginBottom: '24px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                      <Mail size={16} /> Email Address
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      placeholder="Enter your email"
                    />
                  </div>

                  <button 
                    type="submit" 
                    className="btn-primary" 
                    disabled={loading}
                    style={{ width: '100%' }}
                  >
                    {loading ? 'Sending...' : 'Send Reset Link'}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgotPassword;
